import { combineReducers } from 'redux';

import dialogApp from './dialogDetran';

const reducer = combineReducers({
  [dialogApp.name]: dialogApp.reducer,
});

export default reducer;
